/** Shared chart title — simple text label */

import React from "react";
import { px, FONT } from "./chartUtils";
import { E } from "./chartColors";

interface ChartTitleProps {
  label: string;
  S: number;
  unit?: string;
  fontSize?: number;
  marginBottom?: number;
}

export const ChartTitle: React.FC<ChartTitleProps> = ({
  label,
  S,
  unit,
  fontSize = 28,
}) => {
  const title = unit ? `${label}（${unit}）` : label;

  return (
    <div
      style={{
        fontFamily: FONT,
        fontSize: px(fontSize, S),
        fontWeight: 500,
        lineHeight: `${px(fontSize + 12, S)}px`,
        color: E.t3,
        marginBottom: 16,
        width: "100%",
      }}
    >
      {title}
    </div>
  );
};
